// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,500,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, .main-app {
  font-family: 'Roboto', Arial, Helvetica, sans-serif;
}

/* Главный контейнер приложения */
.main-app {
  min-height: 100vh;
}

.main-app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

/* Заголовок приложения */
.app-header {
  background: white;
  color: #1e3a8a;
  padding: 1rem 1rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid #e2e8f0;
}

.header-content {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 1rem;
}

.header-title {
  display: flex;
  align-items: center;
  gap: 1rem;
  min-width: 0;
  justify-self: start;
}

.app-logo {
  flex-shrink: 0;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  transition: transform 0.3s ease;
}

.app-logo:hover {
  transform: scale(1.05);
}

.dark-theme .app-logo {
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.header-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
  justify-self: end;
}

.app-header h1 {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  color: #1e3a8a;
  letter-spacing: -0.5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.team-display {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #f8fafc;
  padding: 0.7rem 1.2rem;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.team-label {
  font-size: 0.9rem;
  color: #64748b;
  font-weight: 500;
}

.team-name {
  font-weight: 600;
  font-size: 1rem;
  color: #1e3a8a;
}

/* .dark-theme .team-name {
  color: #ffffff;
} */

.change-team-btn {
  background: none;
  border: none;
  color: #3bbedb;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.2rem;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.change-team-btn:hover {
  background: #e6f4fa;
}

.theme-toggle-btn {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #3bbedb;
  cursor: pointer;
  font-size: 1.3rem;
  padding: 0.6rem;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.theme-toggle-btn:hover {
  background: #e6f4fa;
  transform: scale(1.1) rotate(180deg);
  box-shadow: 0 4px 12px rgba(59, 190, 219, 0.15);
}

.theme-toggle-btn:active {
  transform: scale(0.95);
}

/* Навигация в шапке */
.header-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  justify-self: center;
}

.main-cat {
  position: absolute;
  top: 100%;
  left: 1rem;
  z-index: 90;
  width: 120px;
  height: 70px;
  pointer-events: none;
}

.main-cat .cat-container {
  position: relative !important;
  inset: auto !important;
  width: 120px !important;
  height: 70px !important;
  pointer-events: none;
  z-index: 1;
  overflow: visible;
}

.main-cat .cat {
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  transform: scale(0.85) !important;
  pointer-events: auto;
}

.nav-btn {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #1e3a8a;
  padding: 0.5rem 1rem;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  font-weight: 500;
}

.nav-btn:hover {
  background: #e6f4fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 190, 219, 0.15);
}

.nav-btn.active {
  background: #3bbedb;
  border-color: #3bbedb;
  color: white;
  font-weight: 600;
}

.restart-btn {
  background: #ef4444;
  border-color: #ef4444;
  color: white;
}

.restart-btn:hover {
  background: #dc2626;
}

@media (max-width: 1200px) and (min-width: 769px) {
  .header-content {
    grid-template-columns: 1fr auto;
  }

  .header-nav {
    grid-column: 1 / -1;
    justify-self: center;
  }
}

/* Основной контент */
.app-main {
  flex: 1 1;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

.content-section {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.content-section h2 {
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  font-weight: 600;
}

.content-section p {
  color: #666;
  line-height: 1.6;
}

/* Аналитика */
.analytics-placeholder {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
}

.chart-placeholder {
  background: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
}

.chart-placeholder h3 {
  color: #495057;
  margin-bottom: 1rem;
  font-size: 1.2rem;
}

.chart-area {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 3rem 1rem;
  color: #6c757d;
  font-style: italic;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Настройки */
.settings-form {
  max-width: 500px;
}

.setting-group {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #667eea;
}

.setting-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #333;
}

.setting-group select,
.setting-group input[type="checkbox"] {
  margin-left: 0.5rem;
}

.setting-group select {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  min-width: 150px;
}

.setting-group input[type="checkbox"] {
  margin-right: 0.5rem;
}

/* Подвал */
.app-footer {
  background: white;
  color: #1e3a8a;
  text-align: center;
  padding: 1rem;
  margin-top: auto;
  border-top: 1px solid #e2e8f0;
}

.app-footer p {
  margin: 0;
  font-size: 0.9rem;
  color: #64748b;
  font-weight: 500;
}

/* Burger Menu */
.burger-menu {
  display: none;
  flex-direction: column;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.burger-menu::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(59, 190, 219, 0.1), transparent);
  transition: left 0.5s ease;
}

.burger-menu:hover::before {
  left: 100%;
}

.burger-menu:hover {
  background: linear-gradient(135deg, rgba(59, 190, 219, 0.1), rgba(102, 126, 234, 0.1));
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(59, 190, 219, 0.2);
}

.burger-line {
  width: 25px;
  height: 3px;
  background: linear-gradient(90deg, #3bbedb, #667eea);
  margin: 3px 0;
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  border-radius: 2px;
  position: relative;
  overflow: hidden;
}

.burger-line::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);
  transition: left 0.6s ease;
}

.burger-menu:hover .burger-line::before {
  left: 100%;
}

.burger-menu.active {
  background: linear-gradient(135deg, rgba(59, 190, 219, 0.15), rgba(102, 126, 234, 0.15));
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(59, 190, 219, 0.3);
}

.burger-menu.active .burger-line:nth-child(1) {
  transform: rotate(-45deg) translate(-6px, 6px);
  background: linear-gradient(90deg, #3bbedb, #667eea);
  box-shadow: 0 2px 8px rgba(59, 190, 219, 0.4);
}

.burger-menu.active .burger-line:nth-child(2) {
  opacity: 0;
  transform: scale(0);
  background: linear-gradient(90deg, #667eea, #764ba2);
}

.burger-menu.active .burger-line:nth-child(3) {
  transform: rotate(45deg) translate(-6px, -6px);
  background: linear-gradient(90deg, #667eea, #764ba2);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);
}

/* Анимация при наведении на отдельные линии */
.burger-menu:hover .burger-line:nth-child(1) {
  transform: translateX(2px);
  background: linear-gradient(90deg, #3bbedb, #667eea, #3bbedb);
}

.burger-menu:hover .burger-line:nth-child(2) {
  transform: scaleX(1.1);
  background: linear-gradient(90deg, #667eea, #764ba2, #667eea);
}

.burger-menu:hover .burger-line:nth-child(3) {
  transform: translateX(-2px);
  background: linear-gradient(90deg, #764ba2, #667eea, #764ba2);
}

/* Пульсирующая анимация для активного состояния */
@keyframes burgerPulse {
  0% {
    box-shadow: 0 6px 20px rgba(59, 190, 219, 0.3);
  }
  50% {
    box-shadow: 0 6px 20px rgba(59, 190, 219, 0.5), 0 0 20px rgba(59, 190, 219, 0.2);
  }
  100% {
    box-shadow: 0 6px 20px rgba(59, 190, 219, 0.3);
  }
}

.burger-menu.active {
  animation: burgerPulse 2s ease-in-out infinite;
}

/* Анимация появления линий */
@keyframes burgerLineAppear {
  0% {
    opacity: 0;
    transform: scaleX(0);
  }
  50% {
    opacity: 0.5;
    transform: scaleX(0.5);
  }
  100% {
    opacity: 1;
    transform: scaleX(1);
  }
}

.burger-line {
  animation: burgerLineAppear 0.3s ease-out;
}

.burger-line:nth-child(1) {
  animation-delay: 0.1s;
}

.burger-line:nth-child(2) {
  animation-delay: 0.2s;
}

.burger-line:nth-child(3) {
  animation-delay: 0.3s;
}

/* Темная тема для burger-menu */
.dark-theme .burger-menu {
  background: rgba(255, 255, 255, 0.05);
}

.dark-theme .burger-menu:hover {
  background: linear-gradient(135deg, rgba(59, 190, 219, 0.2), rgba(102, 126, 234, 0.2));
  box-shadow: 0 4px 12px rgba(59, 190, 219, 0.3);
}

.dark-theme .burger-menu.active {
  background: linear-gradient(135deg, rgba(59, 190, 219, 0.25), rgba(102, 126, 234, 0.25));
  box-shadow: 0 6px 20px rgba(59, 190, 219, 0.4);
}

.dark-theme .burger-line {
  background: linear-gradient(90deg, #e2e8f0, #cbd5e0);
}

.dark-theme .burger-menu:hover .burger-line:nth-child(1) {
  background: linear-gradient(90deg, #3bbedb, #667eea, #3bbedb);
}

.dark-theme .burger-menu:hover .burger-line:nth-child(2) {
  background: linear-gradient(90deg, #667eea, #764ba2, #667eea);
}

.dark-theme .burger-menu:hover .burger-line:nth-child(3) {
  background: linear-gradient(90deg, #764ba2, #667eea, #764ba2);
}

.dark-theme .burger-menu.active .burger-line:nth-child(1) {
  background: linear-gradient(90deg, #3bbedb, #667eea);
  box-shadow: 0 2px 8px rgba(59, 190, 219, 0.5);
}

.dark-theme .burger-menu.active .burger-line:nth-child(3) {
  background: linear-gradient(90deg, #667eea, #764ba2);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.5);
}

/* Анимация для мобильного меню */
.mobile-menu {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  backdrop-filter: blur(5px);
  animation: menuBackdrop 0.3s ease;
}

@keyframes menuBackdrop {
  from {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(5px);
  }
}

.mobile-menu.active {
  display: flex;
}

.mobile-menu-content {
  background: white;
  width: 100%;
  max-width: 300px;
  height: 100%;
  overflow-y: auto;
  padding: 2rem 1rem;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  animation: slideInLeft 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  position: relative;
}

.mobile-menu-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #3bbedb, #667eea, #764ba2);
  animation: gradientFlow 3s ease-in-out infinite;
}

@keyframes gradientFlow {
  0%, 100% {
    background: linear-gradient(90deg, #3bbedb, #667eea, #764ba2);
  }
  50% {
    background: linear-gradient(90deg, #764ba2, #3bbedb, #667eea);
  }
}

.mobile-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e2e8f0;
  animation: fadeInDown 0.5s ease 0.2s both;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mobile-menu-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #666;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.mobile-menu-close::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: linear-gradient(135deg, #3bbedb, #667eea);
  border-radius: 50%;
  transition: all 0.3s ease;
  transform: translate(-50%, -50%);
}

.mobile-menu-close:hover::before {
  width: 100%;
  height: 100%;
}

.mobile-menu-close:hover {
  color: white;
  transform: scale(1.1);
}

.mobile-menu-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  animation: fadeInLeft 0.5s ease both;
}

.mobile-menu-item:nth-child(1) { animation-delay: 0.3s; }
.mobile-menu-item:nth-child(2) { animation-delay: 0.4s; }
.mobile-menu-item:nth-child(3) { animation-delay: 0.5s; }

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.mobile-menu-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(59, 190, 219, 0.1), transparent);
  transition: left 0.5s ease;
}

.mobile-menu-item:hover::before {
  left: 100%;
}

.mobile-menu-item:hover {
  background: linear-gradient(135deg, rgba(59, 190, 219, 0.1), rgba(102, 126, 234, 0.1));
  transform: translateX(5px);
  box-shadow: 0 4px 12px rgba(59, 190, 219, 0.15);
}

.mobile-menu-item.active {
  background: linear-gradient(135deg, #3bbedb, #667eea);
  color: white;
  transform: translateX(5px);
  box-shadow: 0 4px 12px rgba(59, 190, 219, 0.3);
}

.mobile-team-display {
  background: linear-gradient(135deg, #f8fafc, #e6f4fa);
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  border: 1px solid #e2e8f0;
  animation: fadeInUp 0.5s ease 0.1s both;
  position: relative;
  overflow: hidden;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mobile-team-display::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #3bbedb, #667eea, #764ba2);
  animation: slideInRight 2s ease-in-out infinite;
}

@keyframes slideInRight {
  0% {
    left: -100%;
  }
  50% {
    left: 100%;
  }
  100% {
    left: 100%;
  }
}

.mobile-admin-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 1rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  margin-bottom: 1rem;
  position: relative;
  overflow: hidden;
  animation: fadeInUp 0.5s ease 0.2s both;
}

.mobile-admin-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.6s ease;
}

.mobile-admin-btn:hover::before {
  left: 100%;
}

.mobile-admin-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
}

/* Модальные окна */
.password-modal-overlay,
.admin-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  backdrop-filter: blur(5px);
}

.password-modal,
.admin-modal {
  background: white;
  border-radius: 16px;
  max-width: 90vw;
  max-height: 90vh;
  width: 30%;
  overflow: hidden;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: modalSlideIn 0.3s ease;
}

.dark-theme .password-modal,
.dark-theme .admin-modal {
  background: #2d3748;
  color: white;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-30px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.password-modal-header,
.admin-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.dark-theme .password-modal-header,
.dark-theme .admin-modal-header {
  background: #1a202c;
  border-bottom-color: #4a5568;
}

.password-modal-header h3,
.admin-modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.dark-theme .password-modal-header h3,
.dark-theme .admin-modal-header h3 {
  color: #ffffff;
}

.password-modal-close,
.admin-modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.dark-theme .password-modal-close,
.dark-theme .admin-modal-close {
  color: #a0aec0;
}

.password-modal-close:hover,
.admin-modal-close:hover {
  background: #e2e8f0;
  color: #333;
}

.dark-theme .password-modal-close:hover,
.dark-theme .admin-modal-close:hover {
  background: #4a5568;
  color: #ffffff;
}

.password-form {
  padding: 25px;
}

.password-input-group {
  margin-bottom: 20px;
}

.password-input-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.dark-theme .password-input-group label {
  color: #ffffff;
}

.password-input-group input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.dark-theme .password-input-group input {
  background: #4a5568;
  border-color: #4a5568;
  color: #ffffff;
}

.password-input-group input:focus {
  outline: none;
  border-color: #3bbedb;
  box-shadow: 0 0 0 3px rgba(59, 190, 219, 0.1);
}

.dark-theme .password-input-group input:focus {
  border-color: #3bbedb;
  box-shadow: 0 0 0 3px rgba(59, 190, 219, 0.2);
}

.password-input-group small {
  display: block;
  margin-top: 8px;
  font-size: 12px;
  color: #666;
  font-style: italic;
}

.dark-theme .password-input-group small {
  color: #a0aec0;
}

.password-form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.password-form-actions button {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.password-form-actions button[type="button"] {
  background: #e2e8f0;
  color: #333;
}

.dark-theme .password-form-actions button[type="button"] {
  background: #4a5568;
  color: #ffffff;
}

.password-form-actions button[type="button"]:hover {
  background: #cbd5e0;
}

.dark-theme .password-form-actions button[type="button"]:hover {
  background: #2d3748;
}

.password-form-actions button[type="submit"] {
  background: #3bbedb;
  color: white;
}

.password-form-actions button[type="submit"]:hover {
  background: #2a9bb8;
}

.admin-modal-content {
  padding: 0;
  overflow: auto;
  max-height: calc(90vh - 80px);
}

/* Адаптивность для модальных окон */
@media (max-width: 768px) {
  .password-modal,
  .admin-modal {
    max-width: 95vw;
    max-height: 95vh;
  }
  
  .password-form {
    padding: 20px;
  }
  
  .password-form-actions {
    flex-direction: column;
  }
  
  .password-form-actions button {
    width: 100%;
  }
}

/* Адаптивность */
@media (max-width: 768px) {
  .app-header {
    padding: 1rem;
  }
  
  .header-content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }

  .header-title {
    justify-self: auto;
    justify-content: space-between;
    gap: 0.5rem;
  }

  .header-controls {
    justify-self: auto;
  }
  
  .app-logo {
    width: 30px;
    height: 35px;
  }
  
  .app-header h1 {
    font-size: 1.4rem;
    flex: 1 1;
  }
  
  .header-controls {
    justify-content: space-between;
    gap: 0.5rem;
  }
  
  .team-display {
    display: none; /* Скрываем на мобильных */
  }
  
  .theme-toggle-btn {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }
  
  .admin-panel-btn {
    display: none; /* Скрываем на мобильных */
  }
  
  .burger-menu {
    display: flex;
  }

  .header-nav {
    display: none;
  }
  
  .nav-btn {
    padding: 0.4rem 0.8rem;
    font-size: 0.8rem;
  }
  
  .app-main {
    padding: 1rem;
    width: 100%;
    max-width: none;
  }

  .main-cat {
    left: 1rem;
  }
  
  .content-section {
    padding: 1rem;
    margin-bottom: 1rem;
    width: 100%;
    box-sizing: border-box;
  }
  
  .analytics-placeholder {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

@media (max-width: 480px) {
  .app-header {
    padding: 1rem 1rem;
  }
  
  .app-header h1 {
    font-size: 1.2rem;
  }
  
  .header-controls {
    gap: 0.25rem;
  }
  
  .theme-toggle-btn {
    width: 30px;
    height: 30px;
    font-size: 0.9rem;
  }
  
  .app-main {
    padding: 0.75rem;
  }

  .main-cat {
    left: 0.75rem;
  }
  
  .content-section {
    padding: 0.75rem;
  }
  
  .nav-btn {
    padding: 0.3rem 0.6rem;
    font-size: 0.75rem;
  }
}

/* Анимации */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideInLeft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

.content-section {
  animation: fadeIn 0.5s ease-out;
}

/* Темная тема */
.main-app.dark-theme {
  background: #1a1a1a;
  color: #ffffff;
}

.main-app.dark-theme .main-app-container {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
}

.main-app.dark-theme .app-header {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
}

.main-app.dark-theme .content-section {
  background: #2d2d2d;
  color: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.main-app.dark-theme .content-section h2,
.main-app.dark-theme .content-section h3 {
  color: #ffffff;
}

.main-app.dark-theme .content-section p {
  color: #bdc3c7;
}

.main-app.dark-theme .chart-placeholder {
  background: #3d3d3d;
  border-color: #555;
}

.main-app.dark-theme .chart-area {
  background: #2d2d2d;
  border-color: #555;
  color: #bdc3c7;
}

.main-app.dark-theme .setting-group {
  background: #3d3d3d;
  border-color: #555;
}

.main-app.dark-theme .setting-group label {
  color: #ffffff;
}

.main-app.dark-theme .setting-group select {
  background: #2d2d2d;
  border-color: #555;
  color: #ffffff;
}

.main-app.dark-theme .app-footer {
  background: #1a1a1a;
}

.main-app.dark-theme .theme-toggle-btn {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.4);
}

.main-app.dark-theme .theme-toggle-btn:hover {
  background: rgba(255, 255, 255, 0.25);
}

/* Глобальная темная тема для body */
body.dark-theme {
  background: #1a1a1a;
  color: #ffffff;
}

/* Дополнительные стили для темной темы */
.dark-theme h1,
.dark-theme h2,
.dark-theme h3,
.dark-theme h4,
.dark-theme h5,
.dark-theme h6 {
  color: #ffffff !important;
}

.dark-theme p {
  color: #e2e8f0 !important;
}

.dark-theme label {
  color: #cbd5e0 !important;
}

.dark-theme input,
.dark-theme textarea,
.dark-theme select {
  background: #2d3748 !important;
  border-color: #4a5568 !important;
  color: #e2e8f0 !important;
}

.dark-theme input:focus,
.dark-theme textarea:focus,
.dark-theme select:focus {
  border-color: #667eea !important;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2) !important;
}

/* Стили для process-selector в темной теме */
.dark-theme .process-selector {
  background: #2d2d2d !important;
  border: 1px solid #4a5568 !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3) !important;
}

.dark-theme .selector-group {
  background: transparent !important;
}

.dark-theme .selector-label {
  color: #e2e8f0 !important;
}

.dark-theme .selector-btn {
  background: #3d3d3d !important;
  border: 1px solid #4a5568 !important;
  color: #e2e8f0 !important;
}

.dark-theme .selector-btn:hover {
  background: #4a5568 !important;
  color: #ffffff !important;
}

.dark-theme .selector-btn.selected,
.dark-theme .selector-btn:active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: #ffffff !important;
  border-color: #667eea !important;
}

/* Кнопка админ-панели */
.admin-panel-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
  padding: 0.7rem 1.2rem;
  border-radius: 12px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.admin-panel-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
}

.dark-theme .admin-panel-btn {
  box-shadow: 0 4px 12px rgba(44, 62, 80, 0.3);
}

.dark-theme .admin-panel-btn:hover {
  box-shadow: 0 6px 20px rgba(44, 62, 80, 0.4);
}

/* Модальные окна */
.password-modal-overlay,
.admin-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  backdrop-filter: blur(5px);
}

.password-modal,
.admin-modal {
  background: white;
  border-radius: 16px;
  max-width: 90vw;
  max-height: 90vh;
  width: 30%;
  overflow: hidden;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: modalSlideIn 0.3s ease;
}

.dark-theme .password-modal,
.dark-theme .admin-modal {
  background: #2d3748;
  color: white;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-30px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.password-modal-header,
.admin-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.dark-theme .password-modal-header,
.dark-theme .admin-modal-header {
  background: #1a202c;
  border-bottom-color: #4a5568;
}

.password-modal-header h3,
.admin-modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.dark-theme .password-modal-header h3,
.dark-theme .admin-modal-header h3 {
  color: #ffffff;
}

.password-modal-close,
.admin-modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.dark-theme .password-modal-close,
.dark-theme .admin-modal-close {
  color: #a0aec0;
}

.password-modal-close:hover,
.admin-modal-close:hover {
  background: #e2e8f0;
  color: #333;
}

.dark-theme .password-modal-close:hover,
.dark-theme .admin-modal-close:hover {
  background: #4a5568;
  color: #ffffff;
}

.password-form {
  padding: 25px;
}

.password-input-group {
  margin-bottom: 20px;
}

.password-input-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.dark-theme .password-input-group label {
  color: #ffffff;
}

.password-input-group input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.dark-theme .password-input-group input {
  background: #4a5568;
  border-color: #4a5568;
  color: #ffffff;
}

.password-input-group input:focus {
  outline: none;
  border-color: #3bbedb;
  box-shadow: 0 0 0 3px rgba(59, 190, 219, 0.1);
}

.dark-theme .password-input-group input:focus {
  border-color: #3bbedb;
  box-shadow: 0 0 0 3px rgba(59, 190, 219, 0.2);
}

.password-input-group small {
  display: block;
  margin-top: 8px;
  font-size: 12px;
  color: #666;
  font-style: italic;
}

.dark-theme .password-input-group small {
  color: #a0aec0;
}

.password-form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.password-form-actions button {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.password-form-actions button[type="button"] {
  background: #e2e8f0;
  color: #333;
}

.dark-theme .password-form-actions button[type="button"] {
  background: #4a5568;
  color: #ffffff;
}

.password-form-actions button[type="button"]:hover {
  background: #cbd5e0;
}

.dark-theme .password-form-actions button[type="button"]:hover {
  background: #2d3748;
}

.password-form-actions button[type="submit"] {
  background: #3bbedb;
  color: white;
}

.password-form-actions button[type="submit"]:hover {
  background: #2a9bb8;
}

.admin-modal-content {
  padding: 0;
  overflow: auto;
  max-height: calc(90vh - 80px);
}

/* Адаптивность для модальных окон */
@media (max-width: 768px) {
  .password-modal,
  .admin-modal {
    max-width: 95vw;
    max-height: 95vh;
  }
  
  .password-form {
    padding: 20px;
  }
  
  .password-form-actions {
    flex-direction: column;
  }
  
  .password-form-actions button {
    width: 100%;
  }
}

/* Темная тема для мобильного меню */
.dark-theme .mobile-menu-content {
  background: #2d3748;
  color: #e2e8f0;
}

.dark-theme .mobile-menu-header {
  border-bottom-color: #4a5568;
}

.dark-theme .mobile-menu-close {
  color: #a0aec0;
}

.dark-theme .mobile-menu-close:hover {
  background: #4a5568;
  color: #ffffff;
}

.dark-theme .mobile-menu-item:hover {
  background: linear-gradient(135deg, rgba(59, 190, 219, 0.2), rgba(102, 126, 234, 0.2));
}

.dark-theme .mobile-menu-item.active {
  background: linear-gradient(135deg, #3bbedb, #667eea);
  color: white;
}

.dark-theme .mobile-team-display {
  background: linear-gradient(135deg, #4a5568, #2d3748);
  border-color: #2d3748;
}

.dark-theme .mobile-admin-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.dark-theme .mobile-admin-btn:hover {
  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
} `, "",{"version":3,"sources":["webpack://./src/components/MainApp.css"],"names":[],"mappings":"AAEA;EACE,mDAAmD;AACrD;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,6DAA6D;AAC/D;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iDAAiD;EACjD,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,cAAc;AACd;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qFAAqF;EACrF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sFAAsF;EACtF,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,aAAa;EACb,2DAA2D;EAC3D,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wFAAwF;EACxF,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,oDAAoD;EACpD,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,8CAA8C;EAC9C,oDAAoD;EACpD,8CAA8C;AAChD;;AAEA,8CAA8C;AAC9C;EACE,0BAA0B;EAC1B,6DAA6D;AAC/D;;AAEA;EACE,sBAAsB;EACtB,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,6DAA6D;AAC/D;;AAEA,kDAAkD;AAClD;EACE;IACE,8CAA8C;EAChD;EACA;IACE,gFAAgF;EAClF;EACA;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE,8CAA8C;AAChD;;AAEA,6BAA6B;AAC7B;EACE;IACE,UAAU;IACV,oBAAoB;EACtB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,oBAAoB;EACtB;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,qCAAqC;AACvC;;AAEA;EACE,sFAAsF;EACtF,8CAA8C;AAChD;;AAEA;EACE,wFAAwF;EACxF,8CAA8C;AAChD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,oDAAoD;EACpD,6CAA6C;AAC/C;;AAEA;EACE,oDAAoD;EACpD,8CAA8C;AAChD;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,kEAAkE;EAClE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE;IACE,6DAA6D;EAC/D;EACA;IACE,6DAA6D;EAC/D;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,qDAAqD;EACrD,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA,iCAAiC,qBAAqB,EAAE;AACxD,iCAAiC,qBAAqB,EAAE;AACxD,iCAAiC,qBAAqB,EAAE;;AAExD;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qFAAqF;EACrF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sFAAsF;EACtF,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,WAAW;EACX,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,6DAA6D;AAC/D;;AAEA,mBAAmB;AACnB;;EAEE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,6BAA6B;AAC/B;;AAEA,oCAAoC;AACpC;EACE;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,SAAO;EACT;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,aAAa,EAAE,0BAA0B;EAC3C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa,EAAE,0BAA0B;EAC3C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA,aAAa;AACb;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yCAAyC;AACzC;;;;;;EAME,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;;EAGE,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA,6CAA6C;AAC7C;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,oDAAoD;AACtD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;EAEE,wEAAwE;EACxE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,6DAA6D;AAC/D;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,mBAAmB;AACnB;;EAEE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,6BAA6B;AAC/B;;AAEA,oCAAoC;AACpC;EACE;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700&display=swap');\r\n\r\nbody, .main-app {\r\n  font-family: 'Roboto', Arial, Helvetica, sans-serif;\r\n}\r\n\r\n/* Главный контейнер приложения */\r\n.main-app {\r\n  min-height: 100vh;\r\n}\r\n\r\n.main-app-container {\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\r\n}\r\n\r\n/* Заголовок приложения */\r\n.app-header {\r\n  background: white;\r\n  color: #1e3a8a;\r\n  padding: 1rem 1rem;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 100;\r\n  border-bottom: 1px solid #e2e8f0;\r\n}\r\n\r\n.header-content {\r\n  display: grid;\r\n  grid-template-columns: 1fr auto 1fr;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.header-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  min-width: 0;\r\n  justify-self: start;\r\n}\r\n\r\n.app-logo {\r\n  flex-shrink: 0;\r\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.app-logo:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.dark-theme .app-logo {\r\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));\r\n}\r\n\r\n.header-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  flex-shrink: 0;\r\n  justify-self: end;\r\n}\r\n\r\n.app-header h1 {\r\n  margin: 0;\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  color: #1e3a8a;\r\n  letter-spacing: -0.5px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.team-display {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: #f8fafc;\r\n  padding: 0.7rem 1.2rem;\r\n  border-radius: 12px;\r\n  border: 1px solid #e2e8f0;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.team-label {\r\n  font-size: 0.9rem;\r\n  color: #64748b;\r\n  font-weight: 500;\r\n}\r\n\r\n.team-name {\r\n  font-weight: 600;\r\n  font-size: 1rem;\r\n  color: #1e3a8a;\r\n}\r\n\r\n/* .dark-theme .team-name {\r\n  color: #ffffff;\r\n} */\r\n\r\n.change-team-btn {\r\n  background: none;\r\n  border: none;\r\n  color: #3bbedb;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n  padding: 0.2rem;\r\n  border-radius: 4px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.change-team-btn:hover {\r\n  background: #e6f4fa;\r\n}\r\n\r\n.theme-toggle-btn {\r\n  background: #f8fafc;\r\n  border: 1px solid #e2e8f0;\r\n  color: #3bbedb;\r\n  cursor: pointer;\r\n  font-size: 1.3rem;\r\n  padding: 0.6rem;\r\n  border-radius: 50%;\r\n  width: 45px;\r\n  height: 45px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.theme-toggle-btn:hover {\r\n  background: #e6f4fa;\r\n  transform: scale(1.1) rotate(180deg);\r\n  box-shadow: 0 4px 12px rgba(59, 190, 219, 0.15);\r\n}\r\n\r\n.theme-toggle-btn:active {\r\n  transform: scale(0.95);\r\n}\r\n\r\n/* Навигация в шапке */\r\n.header-nav {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.75rem;\r\n  justify-self: center;\r\n}\r\n\r\n.main-cat {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 1rem;\r\n  z-index: 90;\r\n  width: 120px;\r\n  height: 70px;\r\n  pointer-events: none;\r\n}\r\n\r\n.main-cat .cat-container {\r\n  position: relative !important;\r\n  inset: auto !important;\r\n  width: 120px !important;\r\n  height: 70px !important;\r\n  pointer-events: none;\r\n  z-index: 1;\r\n  overflow: visible;\r\n}\r\n\r\n.main-cat .cat {\r\n  position: absolute !important;\r\n  left: 0 !important;\r\n  top: 0 !important;\r\n  transform: scale(0.85) !important;\r\n  pointer-events: auto;\r\n}\r\n\r\n.nav-btn {\r\n  background: #f8fafc;\r\n  border: 1px solid #e2e8f0;\r\n  color: #1e3a8a;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 25px;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.nav-btn:hover {\r\n  background: #e6f4fa;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(59, 190, 219, 0.15);\r\n}\r\n\r\n.nav-btn.active {\r\n  background: #3bbedb;\r\n  border-color: #3bbedb;\r\n  color: white;\r\n  font-weight: 600;\r\n}\r\n\r\n.restart-btn {\r\n  background: #ef4444;\r\n  border-color: #ef4444;\r\n  color: white;\r\n}\r\n\r\n.restart-btn:hover {\r\n  background: #dc2626;\r\n}\r\n\r\n@media (max-width: 1200px) and (min-width: 769px) {\r\n  .header-content {\r\n    grid-template-columns: 1fr auto;\r\n  }\r\n\r\n  .header-nav {\r\n    grid-column: 1 / -1;\r\n    justify-self: center;\r\n  }\r\n}\r\n\r\n/* Основной контент */\r\n.app-main {\r\n  flex: 1;\r\n  padding: 2rem;\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.content-section {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 2rem;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n  margin-bottom: 2rem;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  overflow: hidden;\r\n}\r\n\r\n.content-section h2 {\r\n  color: #333;\r\n  margin-bottom: 1rem;\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.content-section p {\r\n  color: #666;\r\n  line-height: 1.6;\r\n}\r\n\r\n/* Аналитика */\r\n.analytics-placeholder {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: 2rem;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.chart-placeholder {\r\n  background: #f8f9fa;\r\n  border: 2px dashed #dee2e6;\r\n  border-radius: 8px;\r\n  padding: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n.chart-placeholder h3 {\r\n  color: #495057;\r\n  margin-bottom: 1rem;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.chart-area {\r\n  background: white;\r\n  border: 1px solid #e9ecef;\r\n  border-radius: 6px;\r\n  padding: 3rem 1rem;\r\n  color: #6c757d;\r\n  font-style: italic;\r\n  min-height: 200px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* Настройки */\r\n.settings-form {\r\n  max-width: 500px;\r\n}\r\n\r\n.setting-group {\r\n  margin-bottom: 1.5rem;\r\n  padding: 1rem;\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n  border-left: 4px solid #667eea;\r\n}\r\n\r\n.setting-group label {\r\n  display: block;\r\n  margin-bottom: 0.5rem;\r\n  font-weight: 500;\r\n  color: #333;\r\n}\r\n\r\n.setting-group select,\r\n.setting-group input[type=\"checkbox\"] {\r\n  margin-left: 0.5rem;\r\n}\r\n\r\n.setting-group select {\r\n  padding: 0.5rem;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  background: white;\r\n  min-width: 150px;\r\n}\r\n\r\n.setting-group input[type=\"checkbox\"] {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n/* Подвал */\r\n.app-footer {\r\n  background: white;\r\n  color: #1e3a8a;\r\n  text-align: center;\r\n  padding: 1rem;\r\n  margin-top: auto;\r\n  border-top: 1px solid #e2e8f0;\r\n}\r\n\r\n.app-footer p {\r\n  margin: 0;\r\n  font-size: 0.9rem;\r\n  color: #64748b;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Burger Menu */\r\n.burger-menu {\r\n  display: none;\r\n  flex-direction: column;\r\n  cursor: pointer;\r\n  padding: 0.5rem;\r\n  border-radius: 8px;\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.burger-menu::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: -100%;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(90deg, transparent, rgba(59, 190, 219, 0.1), transparent);\r\n  transition: left 0.5s ease;\r\n}\r\n\r\n.burger-menu:hover::before {\r\n  left: 100%;\r\n}\r\n\r\n.burger-menu:hover {\r\n  background: linear-gradient(135deg, rgba(59, 190, 219, 0.1), rgba(102, 126, 234, 0.1));\r\n  transform: scale(1.05);\r\n  box-shadow: 0 4px 12px rgba(59, 190, 219, 0.2);\r\n}\r\n\r\n.burger-line {\r\n  width: 25px;\r\n  height: 3px;\r\n  background: linear-gradient(90deg, #3bbedb, #667eea);\r\n  margin: 3px 0;\r\n  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n  border-radius: 2px;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.burger-line::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: -100%;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);\r\n  transition: left 0.6s ease;\r\n}\r\n\r\n.burger-menu:hover .burger-line::before {\r\n  left: 100%;\r\n}\r\n\r\n.burger-menu.active {\r\n  background: linear-gradient(135deg, rgba(59, 190, 219, 0.15), rgba(102, 126, 234, 0.15));\r\n  transform: scale(1.1);\r\n  box-shadow: 0 6px 20px rgba(59, 190, 219, 0.3);\r\n}\r\n\r\n.burger-menu.active .burger-line:nth-child(1) {\r\n  transform: rotate(-45deg) translate(-6px, 6px);\r\n  background: linear-gradient(90deg, #3bbedb, #667eea);\r\n  box-shadow: 0 2px 8px rgba(59, 190, 219, 0.4);\r\n}\r\n\r\n.burger-menu.active .burger-line:nth-child(2) {\r\n  opacity: 0;\r\n  transform: scale(0);\r\n  background: linear-gradient(90deg, #667eea, #764ba2);\r\n}\r\n\r\n.burger-menu.active .burger-line:nth-child(3) {\r\n  transform: rotate(45deg) translate(-6px, -6px);\r\n  background: linear-gradient(90deg, #667eea, #764ba2);\r\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);\r\n}\r\n\r\n/* Анимация при наведении на отдельные линии */\r\n.burger-menu:hover .burger-line:nth-child(1) {\r\n  transform: translateX(2px);\r\n  background: linear-gradient(90deg, #3bbedb, #667eea, #3bbedb);\r\n}\r\n\r\n.burger-menu:hover .burger-line:nth-child(2) {\r\n  transform: scaleX(1.1);\r\n  background: linear-gradient(90deg, #667eea, #764ba2, #667eea);\r\n}\r\n\r\n.burger-menu:hover .burger-line:nth-child(3) {\r\n  transform: translateX(-2px);\r\n  background: linear-gradient(90deg, #764ba2, #667eea, #764ba2);\r\n}\r\n\r\n/* Пульсирующая анимация для активного состояния */\r\n@keyframes burgerPulse {\r\n  0% {\r\n    box-shadow: 0 6px 20px rgba(59, 190, 219, 0.3);\r\n  }\r\n  50% {\r\n    box-shadow: 0 6px 20px rgba(59, 190, 219, 0.5), 0 0 20px rgba(59, 190, 219, 0.2);\r\n  }\r\n  100% {\r\n    box-shadow: 0 6px 20px rgba(59, 190, 219, 0.3);\r\n  }\r\n}\r\n\r\n.burger-menu.active {\r\n  animation: burgerPulse 2s ease-in-out infinite;\r\n}\r\n\r\n/* Анимация появления линий */\r\n@keyframes burgerLineAppear {\r\n  0% {\r\n    opacity: 0;\r\n    transform: scaleX(0);\r\n  }\r\n  50% {\r\n    opacity: 0.5;\r\n    transform: scaleX(0.5);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scaleX(1);\r\n  }\r\n}\r\n\r\n.burger-line {\r\n  animation: burgerLineAppear 0.3s ease-out;\r\n}\r\n\r\n.burger-line:nth-child(1) {\r\n  animation-delay: 0.1s;\r\n}\r\n\r\n.burger-line:nth-child(2) {\r\n  animation-delay: 0.2s;\r\n}\r\n\r\n.burger-line:nth-child(3) {\r\n  animation-delay: 0.3s;\r\n}\r\n\r\n/* Темная тема для burger-menu */\r\n.dark-theme .burger-menu {\r\n  background: rgba(255, 255, 255, 0.05);\r\n}\r\n\r\n.dark-theme .burger-menu:hover {\r\n  background: linear-gradient(135deg, rgba(59, 190, 219, 0.2), rgba(102, 126, 234, 0.2));\r\n  box-shadow: 0 4px 12px rgba(59, 190, 219, 0.3);\r\n}\r\n\r\n.dark-theme .burger-menu.active {\r\n  background: linear-gradient(135deg, rgba(59, 190, 219, 0.25), rgba(102, 126, 234, 0.25));\r\n  box-shadow: 0 6px 20px rgba(59, 190, 219, 0.4);\r\n}\r\n\r\n.dark-theme .burger-line {\r\n  background: linear-gradient(90deg, #e2e8f0, #cbd5e0);\r\n}\r\n\r\n.dark-theme .burger-menu:hover .burger-line:nth-child(1) {\r\n  background: linear-gradient(90deg, #3bbedb, #667eea, #3bbedb);\r\n}\r\n\r\n.dark-theme .burger-menu:hover .burger-line:nth-child(2) {\r\n  background: linear-gradient(90deg, #667eea, #764ba2, #667eea);\r\n}\r\n\r\n.dark-theme .burger-menu:hover .burger-line:nth-child(3) {\r\n  background: linear-gradient(90deg, #764ba2, #667eea, #764ba2);\r\n}\r\n\r\n.dark-theme .burger-menu.active .burger-line:nth-child(1) {\r\n  background: linear-gradient(90deg, #3bbedb, #667eea);\r\n  box-shadow: 0 2px 8px rgba(59, 190, 219, 0.5);\r\n}\r\n\r\n.dark-theme .burger-menu.active .burger-line:nth-child(3) {\r\n  background: linear-gradient(90deg, #667eea, #764ba2);\r\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.5);\r\n}\r\n\r\n/* Анимация для мобильного меню */\r\n.mobile-menu {\r\n  display: none;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.8);\r\n  z-index: 1000;\r\n  backdrop-filter: blur(5px);\r\n  animation: menuBackdrop 0.3s ease;\r\n}\r\n\r\n@keyframes menuBackdrop {\r\n  from {\r\n    opacity: 0;\r\n    backdrop-filter: blur(0px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    backdrop-filter: blur(5px);\r\n  }\r\n}\r\n\r\n.mobile-menu.active {\r\n  display: flex;\r\n}\r\n\r\n.mobile-menu-content {\r\n  background: white;\r\n  width: 100%;\r\n  max-width: 300px;\r\n  height: 100%;\r\n  overflow-y: auto;\r\n  padding: 2rem 1rem;\r\n  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\r\n  animation: slideInLeft 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n  position: relative;\r\n}\r\n\r\n.mobile-menu-content::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 4px;\r\n  background: linear-gradient(90deg, #3bbedb, #667eea, #764ba2);\r\n  animation: gradientFlow 3s ease-in-out infinite;\r\n}\r\n\r\n@keyframes gradientFlow {\r\n  0%, 100% {\r\n    background: linear-gradient(90deg, #3bbedb, #667eea, #764ba2);\r\n  }\r\n  50% {\r\n    background: linear-gradient(90deg, #764ba2, #3bbedb, #667eea);\r\n  }\r\n}\r\n\r\n.mobile-menu-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 2rem;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 1px solid #e2e8f0;\r\n  animation: fadeInDown 0.5s ease 0.2s both;\r\n}\r\n\r\n@keyframes fadeInDown {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.mobile-menu-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.5rem;\r\n  color: #666;\r\n  cursor: pointer;\r\n  padding: 0.5rem;\r\n  border-radius: 50%;\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.mobile-menu-close::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 0;\r\n  height: 0;\r\n  background: linear-gradient(135deg, #3bbedb, #667eea);\r\n  border-radius: 50%;\r\n  transition: all 0.3s ease;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.mobile-menu-close:hover::before {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.mobile-menu-close:hover {\r\n  color: white;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.mobile-menu-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  padding: 1rem;\r\n  border-radius: 8px;\r\n  margin-bottom: 0.5rem;\r\n  transition: all 0.3s ease;\r\n  cursor: pointer;\r\n  position: relative;\r\n  overflow: hidden;\r\n  animation: fadeInLeft 0.5s ease both;\r\n}\r\n\r\n.mobile-menu-item:nth-child(1) { animation-delay: 0.3s; }\r\n.mobile-menu-item:nth-child(2) { animation-delay: 0.4s; }\r\n.mobile-menu-item:nth-child(3) { animation-delay: 0.5s; }\r\n\r\n@keyframes fadeInLeft {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(-30px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n.mobile-menu-item::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: -100%;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(90deg, transparent, rgba(59, 190, 219, 0.1), transparent);\r\n  transition: left 0.5s ease;\r\n}\r\n\r\n.mobile-menu-item:hover::before {\r\n  left: 100%;\r\n}\r\n\r\n.mobile-menu-item:hover {\r\n  background: linear-gradient(135deg, rgba(59, 190, 219, 0.1), rgba(102, 126, 234, 0.1));\r\n  transform: translateX(5px);\r\n  box-shadow: 0 4px 12px rgba(59, 190, 219, 0.15);\r\n}\r\n\r\n.mobile-menu-item.active {\r\n  background: linear-gradient(135deg, #3bbedb, #667eea);\r\n  color: white;\r\n  transform: translateX(5px);\r\n  box-shadow: 0 4px 12px rgba(59, 190, 219, 0.3);\r\n}\r\n\r\n.mobile-team-display {\r\n  background: linear-gradient(135deg, #f8fafc, #e6f4fa);\r\n  padding: 1rem;\r\n  border-radius: 8px;\r\n  margin-bottom: 1rem;\r\n  border: 1px solid #e2e8f0;\r\n  animation: fadeInUp 0.5s ease 0.1s both;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n@keyframes fadeInUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.mobile-team-display::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: -100%;\r\n  width: 100%;\r\n  height: 2px;\r\n  background: linear-gradient(90deg, #3bbedb, #667eea, #764ba2);\r\n  animation: slideInRight 2s ease-in-out infinite;\r\n}\r\n\r\n@keyframes slideInRight {\r\n  0% {\r\n    left: -100%;\r\n  }\r\n  50% {\r\n    left: 100%;\r\n  }\r\n  100% {\r\n    left: 100%;\r\n  }\r\n}\r\n\r\n.mobile-admin-btn {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  border: none;\r\n  padding: 1rem;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  width: 100%;\r\n  margin-bottom: 1rem;\r\n  position: relative;\r\n  overflow: hidden;\r\n  animation: fadeInUp 0.5s ease 0.2s both;\r\n}\r\n\r\n.mobile-admin-btn::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: -100%;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\r\n  transition: left 0.6s ease;\r\n}\r\n\r\n.mobile-admin-btn:hover::before {\r\n  left: 100%;\r\n}\r\n\r\n.mobile-admin-btn:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\r\n  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);\r\n}\r\n\r\n/* Модальные окна */\r\n.password-modal-overlay,\r\n.admin-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  padding: 20px;\r\n  backdrop-filter: blur(5px);\r\n}\r\n\r\n.password-modal,\r\n.admin-modal {\r\n  background: white;\r\n  border-radius: 16px;\r\n  max-width: 90vw;\r\n  max-height: 90vh;\r\n  width: 30%;\r\n  overflow: hidden;\r\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\r\n  animation: modalSlideIn 0.3s ease;\r\n}\r\n\r\n.dark-theme .password-modal,\r\n.dark-theme .admin-modal {\r\n  background: #2d3748;\r\n  color: white;\r\n}\r\n\r\n@keyframes modalSlideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.9) translateY(-30px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1) translateY(0);\r\n  }\r\n}\r\n\r\n.password-modal-header,\r\n.admin-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px 25px;\r\n  border-bottom: 1px solid #e2e8f0;\r\n  background: #f8fafc;\r\n}\r\n\r\n.dark-theme .password-modal-header,\r\n.dark-theme .admin-modal-header {\r\n  background: #1a202c;\r\n  border-bottom-color: #4a5568;\r\n}\r\n\r\n.password-modal-header h3,\r\n.admin-modal-header h3 {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.dark-theme .password-modal-header h3,\r\n.dark-theme .admin-modal-header h3 {\r\n  color: #ffffff;\r\n}\r\n\r\n.password-modal-close,\r\n.admin-modal-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  color: #666;\r\n  padding: 8px;\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.dark-theme .password-modal-close,\r\n.dark-theme .admin-modal-close {\r\n  color: #a0aec0;\r\n}\r\n\r\n.password-modal-close:hover,\r\n.admin-modal-close:hover {\r\n  background: #e2e8f0;\r\n  color: #333;\r\n}\r\n\r\n.dark-theme .password-modal-close:hover,\r\n.dark-theme .admin-modal-close:hover {\r\n  background: #4a5568;\r\n  color: #ffffff;\r\n}\r\n\r\n.password-form {\r\n  padding: 25px;\r\n}\r\n\r\n.password-input-group {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.password-input-group label {\r\n  display: block;\r\n  margin-bottom: 8px;\r\n  font-weight: 500;\r\n  color: #333;\r\n}\r\n\r\n.dark-theme .password-input-group label {\r\n  color: #ffffff;\r\n}\r\n\r\n.password-input-group input {\r\n  width: 100%;\r\n  padding: 12px 16px;\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n  transition: border-color 0.2s ease;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.dark-theme .password-input-group input {\r\n  background: #4a5568;\r\n  border-color: #4a5568;\r\n  color: #ffffff;\r\n}\r\n\r\n.password-input-group input:focus {\r\n  outline: none;\r\n  border-color: #3bbedb;\r\n  box-shadow: 0 0 0 3px rgba(59, 190, 219, 0.1);\r\n}\r\n\r\n.dark-theme .password-input-group input:focus {\r\n  border-color: #3bbedb;\r\n  box-shadow: 0 0 0 3px rgba(59, 190, 219, 0.2);\r\n}\r\n\r\n.password-input-group small {\r\n  display: block;\r\n  margin-top: 8px;\r\n  font-size: 12px;\r\n  color: #666;\r\n  font-style: italic;\r\n}\r\n\r\n.dark-theme .password-input-group small {\r\n  color: #a0aec0;\r\n}\r\n\r\n.password-form-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.password-form-actions button {\r\n  padding: 10px 20px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.password-form-actions button[type=\"button\"] {\r\n  background: #e2e8f0;\r\n  color: #333;\r\n}\r\n\r\n.dark-theme .password-form-actions button[type=\"button\"] {\r\n  background: #4a5568;\r\n  color: #ffffff;\r\n}\r\n\r\n.password-form-actions button[type=\"button\"]:hover {\r\n  background: #cbd5e0;\r\n}\r\n\r\n.dark-theme .password-form-actions button[type=\"button\"]:hover {\r\n  background: #2d3748;\r\n}\r\n\r\n.password-form-actions button[type=\"submit\"] {\r\n  background: #3bbedb;\r\n  color: white;\r\n}\r\n\r\n.password-form-actions button[type=\"submit\"]:hover {\r\n  background: #2a9bb8;\r\n}\r\n\r\n.admin-modal-content {\r\n  padding: 0;\r\n  overflow: auto;\r\n  max-height: calc(90vh - 80px);\r\n}\r\n\r\n/* Адаптивность для модальных окон */\r\n@media (max-width: 768px) {\r\n  .password-modal,\r\n  .admin-modal {\r\n    max-width: 95vw;\r\n    max-height: 95vh;\r\n  }\r\n  \r\n  .password-form {\r\n    padding: 20px;\r\n  }\r\n  \r\n  .password-form-actions {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .password-form-actions button {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n/* Адаптивность */\r\n@media (max-width: 768px) {\r\n  .app-header {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .header-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    gap: 1rem;\r\n  }\r\n\r\n  .header-title {\r\n    justify-self: auto;\r\n    justify-content: space-between;\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  .header-controls {\r\n    justify-self: auto;\r\n  }\r\n  \r\n  .app-logo {\r\n    width: 30px;\r\n    height: 35px;\r\n  }\r\n  \r\n  .app-header h1 {\r\n    font-size: 1.4rem;\r\n    flex: 1;\r\n  }\r\n  \r\n  .header-controls {\r\n    justify-content: space-between;\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .team-display {\r\n    display: none; /* Скрываем на мобильных */\r\n  }\r\n  \r\n  .theme-toggle-btn {\r\n    width: 35px;\r\n    height: 35px;\r\n    font-size: 1rem;\r\n  }\r\n  \r\n  .admin-panel-btn {\r\n    display: none; /* Скрываем на мобильных */\r\n  }\r\n  \r\n  .burger-menu {\r\n    display: flex;\r\n  }\r\n\r\n  .header-nav {\r\n    display: none;\r\n  }\r\n  \r\n  .nav-btn {\r\n    padding: 0.4rem 0.8rem;\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .app-main {\r\n    padding: 1rem;\r\n    width: 100%;\r\n    max-width: none;\r\n  }\r\n\r\n  .main-cat {\r\n    left: 1rem;\r\n  }\r\n  \r\n  .content-section {\r\n    padding: 1rem;\r\n    margin-bottom: 1rem;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  .analytics-placeholder {\r\n    grid-template-columns: 1fr;\r\n    gap: 1rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .app-header {\r\n    padding: 1rem 1rem;\r\n  }\r\n  \r\n  .app-header h1 {\r\n    font-size: 1.2rem;\r\n  }\r\n  \r\n  .header-controls {\r\n    gap: 0.25rem;\r\n  }\r\n  \r\n  .theme-toggle-btn {\r\n    width: 30px;\r\n    height: 30px;\r\n    font-size: 0.9rem;\r\n  }\r\n  \r\n  .app-main {\r\n    padding: 0.75rem;\r\n  }\r\n\r\n  .main-cat {\r\n    left: 0.75rem;\r\n  }\r\n  \r\n  .content-section {\r\n    padding: 0.75rem;\r\n  }\r\n  \r\n  .nav-btn {\r\n    padding: 0.3rem 0.6rem;\r\n    font-size: 0.75rem;\r\n  }\r\n}\r\n\r\n/* Анимации */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes slideInLeft {\r\n  from {\r\n    transform: translateX(-100%);\r\n  }\r\n  to {\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n.content-section {\r\n  animation: fadeIn 0.5s ease-out;\r\n}\r\n\r\n/* Темная тема */\r\n.main-app.dark-theme {\r\n  background: #1a1a1a;\r\n  color: #ffffff;\r\n}\r\n\r\n.main-app.dark-theme .main-app-container {\r\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\r\n}\r\n\r\n.main-app.dark-theme .app-header {\r\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\r\n}\r\n\r\n.main-app.dark-theme .content-section {\r\n  background: #2d2d2d;\r\n  color: #ffffff;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.main-app.dark-theme .content-section h2,\r\n.main-app.dark-theme .content-section h3 {\r\n  color: #ffffff;\r\n}\r\n\r\n.main-app.dark-theme .content-section p {\r\n  color: #bdc3c7;\r\n}\r\n\r\n.main-app.dark-theme .chart-placeholder {\r\n  background: #3d3d3d;\r\n  border-color: #555;\r\n}\r\n\r\n.main-app.dark-theme .chart-area {\r\n  background: #2d2d2d;\r\n  border-color: #555;\r\n  color: #bdc3c7;\r\n}\r\n\r\n.main-app.dark-theme .setting-group {\r\n  background: #3d3d3d;\r\n  border-color: #555;\r\n}\r\n\r\n.main-app.dark-theme .setting-group label {\r\n  color: #ffffff;\r\n}\r\n\r\n.main-app.dark-theme .setting-group select {\r\n  background: #2d2d2d;\r\n  border-color: #555;\r\n  color: #ffffff;\r\n}\r\n\r\n.main-app.dark-theme .app-footer {\r\n  background: #1a1a1a;\r\n}\r\n\r\n.main-app.dark-theme .theme-toggle-btn {\r\n  background: rgba(255, 255, 255, 0.15);\r\n  border-color: rgba(255, 255, 255, 0.4);\r\n}\r\n\r\n.main-app.dark-theme .theme-toggle-btn:hover {\r\n  background: rgba(255, 255, 255, 0.25);\r\n}\r\n\r\n/* Глобальная темная тема для body */\r\nbody.dark-theme {\r\n  background: #1a1a1a;\r\n  color: #ffffff;\r\n}\r\n\r\n/* Дополнительные стили для темной темы */\r\n.dark-theme h1,\r\n.dark-theme h2,\r\n.dark-theme h3,\r\n.dark-theme h4,\r\n.dark-theme h5,\r\n.dark-theme h6 {\r\n  color: #ffffff !important;\r\n}\r\n\r\n.dark-theme p {\r\n  color: #e2e8f0 !important;\r\n}\r\n\r\n.dark-theme label {\r\n  color: #cbd5e0 !important;\r\n}\r\n\r\n.dark-theme input,\r\n.dark-theme textarea,\r\n.dark-theme select {\r\n  background: #2d3748 !important;\r\n  border-color: #4a5568 !important;\r\n  color: #e2e8f0 !important;\r\n}\r\n\r\n.dark-theme input:focus,\r\n.dark-theme textarea:focus,\r\n.dark-theme select:focus {\r\n  border-color: #667eea !important;\r\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2) !important;\r\n}\r\n\r\n/* Стили для process-selector в темной теме */\r\n.dark-theme .process-selector {\r\n  background: #2d2d2d !important;\r\n  border: 1px solid #4a5568 !important;\r\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3) !important;\r\n}\r\n\r\n.dark-theme .selector-group {\r\n  background: transparent !important;\r\n}\r\n\r\n.dark-theme .selector-label {\r\n  color: #e2e8f0 !important;\r\n}\r\n\r\n.dark-theme .selector-btn {\r\n  background: #3d3d3d !important;\r\n  border: 1px solid #4a5568 !important;\r\n  color: #e2e8f0 !important;\r\n}\r\n\r\n.dark-theme .selector-btn:hover {\r\n  background: #4a5568 !important;\r\n  color: #ffffff !important;\r\n}\r\n\r\n.dark-theme .selector-btn.selected,\r\n.dark-theme .selector-btn:active {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\r\n  color: #ffffff !important;\r\n  border-color: #667eea !important;\r\n}\r\n\r\n/* Кнопка админ-панели */\r\n.admin-panel-btn {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  border: none;\r\n  color: white;\r\n  padding: 0.7rem 1.2rem;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);\r\n}\r\n\r\n.admin-panel-btn:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);\r\n  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);\r\n}\r\n\r\n.dark-theme .admin-panel-btn {\r\n  box-shadow: 0 4px 12px rgba(44, 62, 80, 0.3);\r\n}\r\n\r\n.dark-theme .admin-panel-btn:hover {\r\n  box-shadow: 0 6px 20px rgba(44, 62, 80, 0.4);\r\n}\r\n\r\n/* Модальные окна */\r\n.password-modal-overlay,\r\n.admin-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  padding: 20px;\r\n  backdrop-filter: blur(5px);\r\n}\r\n\r\n.password-modal,\r\n.admin-modal {\r\n  background: white;\r\n  border-radius: 16px;\r\n  max-width: 90vw;\r\n  max-height: 90vh;\r\n  width: 30%;\r\n  overflow: hidden;\r\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\r\n  animation: modalSlideIn 0.3s ease;\r\n}\r\n\r\n.dark-theme .password-modal,\r\n.dark-theme .admin-modal {\r\n  background: #2d3748;\r\n  color: white;\r\n}\r\n\r\n@keyframes modalSlideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.9) translateY(-30px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1) translateY(0);\r\n  }\r\n}\r\n\r\n.password-modal-header,\r\n.admin-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px 25px;\r\n  border-bottom: 1px solid #e2e8f0;\r\n  background: #f8fafc;\r\n}\r\n\r\n.dark-theme .password-modal-header,\r\n.dark-theme .admin-modal-header {\r\n  background: #1a202c;\r\n  border-bottom-color: #4a5568;\r\n}\r\n\r\n.password-modal-header h3,\r\n.admin-modal-header h3 {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.dark-theme .password-modal-header h3,\r\n.dark-theme .admin-modal-header h3 {\r\n  color: #ffffff;\r\n}\r\n\r\n.password-modal-close,\r\n.admin-modal-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  color: #666;\r\n  padding: 8px;\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.dark-theme .password-modal-close,\r\n.dark-theme .admin-modal-close {\r\n  color: #a0aec0;\r\n}\r\n\r\n.password-modal-close:hover,\r\n.admin-modal-close:hover {\r\n  background: #e2e8f0;\r\n  color: #333;\r\n}\r\n\r\n.dark-theme .password-modal-close:hover,\r\n.dark-theme .admin-modal-close:hover {\r\n  background: #4a5568;\r\n  color: #ffffff;\r\n}\r\n\r\n.password-form {\r\n  padding: 25px;\r\n}\r\n\r\n.password-input-group {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.password-input-group label {\r\n  display: block;\r\n  margin-bottom: 8px;\r\n  font-weight: 500;\r\n  color: #333;\r\n}\r\n\r\n.dark-theme .password-input-group label {\r\n  color: #ffffff;\r\n}\r\n\r\n.password-input-group input {\r\n  width: 100%;\r\n  padding: 12px 16px;\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n  transition: border-color 0.2s ease;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.dark-theme .password-input-group input {\r\n  background: #4a5568;\r\n  border-color: #4a5568;\r\n  color: #ffffff;\r\n}\r\n\r\n.password-input-group input:focus {\r\n  outline: none;\r\n  border-color: #3bbedb;\r\n  box-shadow: 0 0 0 3px rgba(59, 190, 219, 0.1);\r\n}\r\n\r\n.dark-theme .password-input-group input:focus {\r\n  border-color: #3bbedb;\r\n  box-shadow: 0 0 0 3px rgba(59, 190, 219, 0.2);\r\n}\r\n\r\n.password-input-group small {\r\n  display: block;\r\n  margin-top: 8px;\r\n  font-size: 12px;\r\n  color: #666;\r\n  font-style: italic;\r\n}\r\n\r\n.dark-theme .password-input-group small {\r\n  color: #a0aec0;\r\n}\r\n\r\n.password-form-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.password-form-actions button {\r\n  padding: 10px 20px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.password-form-actions button[type=\"button\"] {\r\n  background: #e2e8f0;\r\n  color: #333;\r\n}\r\n\r\n.dark-theme .password-form-actions button[type=\"button\"] {\r\n  background: #4a5568;\r\n  color: #ffffff;\r\n}\r\n\r\n.password-form-actions button[type=\"button\"]:hover {\r\n  background: #cbd5e0;\r\n}\r\n\r\n.dark-theme .password-form-actions button[type=\"button\"]:hover {\r\n  background: #2d3748;\r\n}\r\n\r\n.password-form-actions button[type=\"submit\"] {\r\n  background: #3bbedb;\r\n  color: white;\r\n}\r\n\r\n.password-form-actions button[type=\"submit\"]:hover {\r\n  background: #2a9bb8;\r\n}\r\n\r\n.admin-modal-content {\r\n  padding: 0;\r\n  overflow: auto;\r\n  max-height: calc(90vh - 80px);\r\n}\r\n\r\n/* Адаптивность для модальных окон */\r\n@media (max-width: 768px) {\r\n  .password-modal,\r\n  .admin-modal {\r\n    max-width: 95vw;\r\n    max-height: 95vh;\r\n  }\r\n  \r\n  .password-form {\r\n    padding: 20px;\r\n  }\r\n  \r\n  .password-form-actions {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .password-form-actions button {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n/* Темная тема для мобильного меню */\r\n.dark-theme .mobile-menu-content {\r\n  background: #2d3748;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .mobile-menu-header {\r\n  border-bottom-color: #4a5568;\r\n}\r\n\r\n.dark-theme .mobile-menu-close {\r\n  color: #a0aec0;\r\n}\r\n\r\n.dark-theme .mobile-menu-close:hover {\r\n  background: #4a5568;\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-theme .mobile-menu-item:hover {\r\n  background: linear-gradient(135deg, rgba(59, 190, 219, 0.2), rgba(102, 126, 234, 0.2));\r\n}\r\n\r\n.dark-theme .mobile-menu-item.active {\r\n  background: linear-gradient(135deg, #3bbedb, #667eea);\r\n  color: white;\r\n}\r\n\r\n.dark-theme .mobile-team-display {\r\n  background: linear-gradient(135deg, #4a5568, #2d3748);\r\n  border-color: #2d3748;\r\n}\r\n\r\n.dark-theme .mobile-admin-btn {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n}\r\n\r\n.dark-theme .mobile-admin-btn:hover {\r\n  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
